import React, { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

interface Props {
  markdown: string;
  className?: string;
}

// Renderiza markdown sanitizado (descrição e comentários de demandas)
export default function MarkdownView({ markdown, className = '' }: Props) {
  const html = useMemo(() => {
    if (!markdown) return '';
    const raw = marked.parse(markdown, { async: false, breaks: true }) as string;
    return DOMPurify.sanitize(raw);
  }, [markdown]);

  if (!markdown) return null;

  return (
    <div
      className={`text-sm text-slate-300 leading-relaxed break-words [&_a]:text-orange-400 [&_a]:underline [&_code]:bg-slate-800 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-orange-300 [&_pre]:bg-slate-800 [&_pre]:p-3 [&_pre]:rounded-lg [&_pre]:overflow-x-auto [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_blockquote]:border-l-2 [&_blockquote]:border-slate-600 [&_blockquote]:pl-3 [&_blockquote]:text-slate-400 [&_h1]:text-lg [&_h1]:font-bold [&_h1]:text-white [&_h2]:text-base [&_h2]:font-bold [&_h2]:text-white [&_h3]:text-sm [&_h3]:font-bold [&_h3]:text-white [&_p]:mb-2 last:[&_p]:mb-0 [&_strong]:text-white ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
